var _mask, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9756 2.44764C13.1748 2.24899 13.1748 1.95101 12.9756 1.75236L12.3117 1.05709C12.1125 0.858446 11.8137 0.858446 11.6145 1.05709L7.26558 5.39426C7.13279 5.52669 6.9336 5.52669 6.80081 5.39426L2.4519 1.02399C2.25271 0.825338 1.95393 0.825338 1.75474 1.02399L1.05759 1.71926C0.858401 1.91791 0.858401 2.21588 1.05759 2.41453L5.4065 6.75169C5.5393 6.88412 5.5393 7.08277 5.4065 7.2152L1.02439 11.5855C0.825203 11.7841 0.825203 12.0821 1.02439 12.2807L1.72154 12.976C1.92073 13.1747 2.21951 13.1747 2.4187 12.976L6.76762 8.63885C6.90041 8.50642 7.09959 8.50642 7.23238 8.63885L11.5813 12.976C11.7805 13.1747 12.0793 13.1747 12.2785 12.976L12.9756 12.2807C13.1748 12.0821 13.1748 11.7841 12.9756 11.5855L8.65989 7.24831C8.5271 7.11588 8.5271 6.91723 8.65989 6.7848L12.9756 2.44764Z",
    fill: "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.3b45570325c482af0ccb1bc5c9164d7d.svg";
export { ForwardRef as ReactComponent };